export const MAX_CHAT_ATTACHMENTS = 10;
export const MAX_CHAT_ATTACHMENT_BYTES = 20 * 1024 * 1024;

export const CHAT_ATTACHMENT_ACCEPT = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'image/heif',
    'video/mp4',
    'video/quicktime',
    'video/webm',
    '.jpg',
    '.jpeg',
    '.png',
    '.webp',
    '.heic',
    '.heif',
    '.mp4',
    '.mov',
    '.webm',
].join(',');

const CONTENT_TYPES = new Set([
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'image/heif',
    'video/mp4',
    'video/quicktime',
    'video/webm',
]);

const EXTENSION_CONTENT_TYPES = new Map([
    ['jpg', 'image/jpeg'],
    ['jpeg', 'image/jpeg'],
    ['png', 'image/png'],
    ['webp', 'image/webp'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['mp4', 'video/mp4'],
    ['mov', 'video/quicktime'],
    ['webm', 'video/webm'],
]);

export function normalizedAttachmentContentType(file) {
    const declared = (file?.type || '').toLowerCase();
    if (declared === 'image/jpg') return 'image/jpeg';
    if (CONTENT_TYPES.has(declared)) return declared;
    const extension = (file?.name || '').split('.').at(-1)?.toLowerCase();
    return EXTENSION_CONTENT_TYPES.get(extension) || '';
}

export function validateChatAttachment(file) {
    if (!file || !file.name || [...file.name].length > 255) return 'The file name is invalid.';
    if (!normalizedAttachmentContentType(file)) return 'Only photos (JPEG, PNG, WebP, HEIC/HEIF) and videos (MP4, MOV, WebM) are supported.';
    if (file.size <= 0) return 'The file is empty.';
    if (file.size > (normalizedAttachmentContentType(file).startsWith('video/') ? 100 * 1024 * 1024 : MAX_CHAT_ATTACHMENT_BYTES)) return 'Photos must be 20 MB or smaller; videos 100 MB or smaller.';
    return null;
}

export function formatAttachmentSize(size) {
    if (!Number.isFinite(size) || size < 0) return '';
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(size < 10 * 1024 ? 1 : 0)} KB`;
    return `${(size / (1024 * 1024)).toFixed(size < 10 * 1024 * 1024 ? 1 : 0)} MB`;
}

export function isPreviewableAttachment(attachment) {
    const contentType = attachment?.content_type || '';
    return contentType.startsWith('image/') || contentType.startsWith('video/');
}
